// extracted by mini-css-extract-plugin
module.exports = {"profile":"profile_profile__26YER","title":"profile_title__20YT7"};